module.exports = __webpack_public_path__ + "media/שיר.b267add6.mp3";